import { ROUTE_PERMISSION } from '../../config/permission.config.js'

export default [
  { path: '', redirect: '/overview' },
  {
    path: 'overview',
    name: 'Overview',
    component: () => import('../../views/account/OverviewPage.vue'),
    meta: {
      requiresAuth: true,
      layoutRoot: true,
      title: 'Yhteenveto - Vuokranet',
    },
  },
  {
    path: 'tehtavat/hallinta',
    name: 'TicketManagement',
    component: () => import('../../views/account/tickets/ManagementPage.vue'),
    meta: {
      requiresAuth: true,
      permission: ROUTE_PERMISSION.TICKET_MANAGEMENT,
      title: 'Tehtävien hallinta - Vuokranet',
    },
  },
  {
    path: 'tehtavat/hallinta/uusi',
    name: 'TicketEditorNew',
    component: () => import('../../views/account/tickets/EditorPage.vue'),
    meta: {
      requiresAuth: true,
      permission: ROUTE_PERMISSION.TICKET_MANAGEMENT,
      ticketResourceCreate: true,
      title: 'Uusi tehtävä - Vuokranet',
    },
  },
  {
    path: 'tehtavat/hallinta/:id/attachment/:attachmentId',
    name: 'TicketAttachmentPdf',
    component: () => import('../../views/PdfViewerPage.vue'),
    meta: {
      requiresAuth: true,
      permission: ROUTE_PERMISSION.TICKET_MANAGEMENT,
      title: 'PDF - Vuokranet',
    },
  },
  {
    path: 'tehtavat/hallinta/:id',
    name: 'TicketEditor',
    component: () => import('../../views/account/tickets/EditorPage.vue'),
    meta: {
      requiresAuth: true,
      permission: ROUTE_PERMISSION.TICKET_MANAGEMENT,
      title: 'Muokkaa tehtävää - Vuokranet',
    },
  },
  {
    path: 'tehtavat/seuranta',
    name: 'TicketTracking',
    component: () => import('../../views/account/tickets/TrackingPage.vue'),
    meta: {
      requiresAuth: true,
      permission: ROUTE_PERMISSION.TICKET_TRACKING,
      title: 'Tehtävien seuranta - Vuokranet',
    },
  },
  {
    path: 'tehtavat/asetukset',
    name: 'TicketSettings',
    component: () => import('../../views/account/tickets/SettingsPage.vue'),
    meta: {
      requiresAuth: true,
      permission: ROUTE_PERMISSION.TICKET_SETTINGS,
      title: 'Tehtävien asetukset - Vuokranet',
    },
  },
]
